import React from 'react';
import { Link } from 'react-router-dom';
import { getEnabledSocialPlatforms } from '../data/socialConfig';
import { getLandingsByType } from '../data/landingsConfig';
import SiteLogo from './SiteLogo';
import ChannelLink from './social/ChannelLink';
import LandingMark from './LandingMark';
import { pillTokens } from '../styles/pillTokens';
import { labelTokens } from '../styles/labelTokens';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const socialLinks = getEnabledSocialPlatforms();
  
  return (
        <footer className="bg-white dark:bg-dark mb-bottom-nav lg:rounded-2xl lg:border lg:border-gray-200 dark:lg:border-gray-700 lg:mb-6">
       <div className="container-narrow py-6 md:py-10">
        {/* Main content grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
          {/* Brand section */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-3">
              <SiteLogo className="h-6 w-auto" />
                             <h3 className="text-xl leading-none font-bold text-gray-900 dark:text-white mb-0">
                 Main-Bet
               </h3>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed mb-4 max-w-md">
              Daily football picks, accas, and bookmaker guides for fans in India, Africa &amp; beyond.
            </p>
            
            {/* Social links */}
            <div className="flex gap-3">
              {socialLinks.map((social) => {
                const IconComponent = social.icon;
                return (
                  <ChannelLink
                    key={social.name}
                    channel={social.name.toLowerCase()}
                    placement="footer"
                    aria-label={`Follow us on ${social.name}`}
                    className="w-11 h-11 bg-gray-100 dark:bg-gray-800 rounded-xl flex items-center justify-center text-gray-600 dark:text-gray-400 transition-colors duration-300 hover:bg-primary/10 hover:text-primary dark:hover:bg-primary/20"
                  >
                    <IconComponent size={18} />
                  </ChannelLink>
                );
              })}
            </div>
          </div>
          
          {/* Navigation links */}
          <div>
            <h4 className={`${labelTokens.overline} mb-1`}>Quick Links</h4>
            <nav aria-label="Footer navigation">
              <ul className="grid grid-cols-2 md:grid-cols-1 gap-x-4">
                {[
                  { to: '/', label: 'Predictions' },
                  { to: '/results', label: 'Results' },
                  { to: '/accumulators/', label: 'Accumulators' },
                  { to: '/best-betting-sites', label: 'Best Betting Sites' },
                  { to: '/bookie-bonuses/', label: 'Bookmaker Bonuses' },
                  { to: '/betting-guides/', label: 'Betting Guides' },
                  { to: '/about', label: 'About Us' },
                  { to: '/privacy-policy', label: 'Privacy Policy' }
                ].map((link, index) => (
                  <li key={index}>
                    <Link 
                      to={link.to} 
                      className="flex items-center min-h-[44px] text-sm text-gray-600 dark:text-gray-300 hover:text-primary dark:hover:text-primary-light transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
          
          {/* Legal section */}
          <div>
            <h4 className={`${labelTokens.overline} mb-3`}>Legal</h4>

            <div className="space-y-3">
              <div className="p-3 bg-warning-light/80 dark:bg-warning/10 rounded-xl border border-warning/20">
                <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                  <span className="text-warning-dark dark:text-warning-bright font-medium">18+</span> Please gamble responsibly. 
                  Our predictions are for informational purposes only.
                </p>
              </div>
              
              <div className="text-xs text-gray-500 dark:text-gray-400 space-y-1">
                <p>Independent predictions. We are not a bookmaker and do not accept bets.</p>
                <p>Some bookmaker links are affiliate links.</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Leagues & Betting Tips */}
        <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700/50 grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div>
            <h4 className={`${labelTokens.overline} mb-3`}>
              League Predictions
            </h4>
            <div className="flex flex-wrap gap-2">
              {getLandingsByType('league').map(l => (
                <Link
                  key={l.slug}
                  to={`/${l.slug}`}
                  className={`${pillTokens.chip} gap-1.5`}
                >
                  <LandingMark landing={l} size={14} />
                  {l.title.replace(' Predictions Today', '').replace(' Predictions', '')}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className={`${labelTokens.overline} mb-3`}>
              Betting Tips
            </h4>
            <div className="flex flex-wrap gap-2">
              {getLandingsByType('betType').map(l => (
                <Link
                  key={l.slug}
                  to={`/${l.slug}`}
                  className={`${pillTokens.chip} gap-1.5`}
                >
                  <LandingMark landing={l} size={14} />
                  {l.title.replace(' Predictions', ' Tips')}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom section */}
        <div className="mt-6 pt-6 border-t border-gray-200 dark:border-gray-700/50">
          <p className="text-sm text-gray-500 dark:text-gray-400 text-center sm:text-left">
            &copy; {currentYear} Main-Bet. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 